<template>
    <div
        class="flex-col gap-4 flex py-10 px-4 sm:px-6 lg:px-8 shadow-lg rounded-lg bg-white border border-gray-200"
    >
        <div v-if="donationSuccess" class="rounded-md bg-green-50 mb-10">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div class="flex p-4">
                    <div class="flex-shrink-0">
                        <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm font-medium text-green-800">
                            Payment successful!
                        </h3>
                        <div class="mt-2 text-sm text-green-700">
                            <p>Your payment has been completed successfully.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <message
            :user="user"
            :signature="signature"
            :reduction-statement="reductionStatement"
        ></message>
        <div class="flex justify-center">
            <p class="text-lg sm:text-xl font-bold text-gray-800 mb-4 sm:mb-0">
                Final Order Ready
            </p>
        </div>

        <div
            class="flex flex-col divide-y divide-gray-200 border-b border-gray-200"
        >
            <div
                v-for="userProperty in userProperties"
                class="flex flex-col gap-4 py-4"
            >
                <div
                    v-if="userProperty.final_order_pdf"
                    class="overflow-hidden ring-1 ring-gray-200 sm:rounded-lg"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                            <tr class="divide-x divide-gray-200">
                                <th
                                    scope="col"
                                    class="pl-4 pr-3 py-4 sm:pl-6 text-left"
                                >
                                    <label
                                        for="email"
                                        class="block text-xs font-medium leading-6 text-gray-600"
                                        >Property Address</label
                                    >
                                    <p class="-mt-1.5 text-indigo-600">
                                        {{ userProperty.Situs_Address }} (#{{
                                            userProperty.account_no
                                        }})
                                    </p>
                                </th>
                                <th
                                    scope="col"
                                    v-if="userProperty.show_2022_field"
                                    class="px-3 py-3.5 text-sm w-28 font-semibold text-gray-700 text-right"
                                >
                                    2022
                                </th>
                                <th
                                    scope="col"
                                    class="px-3 py-3.5 w-28 text-sm font-semibold text-gray-700 text-right"
                                >
                                    2023
                                </th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 bg-white">
                            <tr
                                v-if="
                                    userProperty.is_tad_evidence_value_greater_than_final_order_value
                                "
                                class="divide-x divide-gray-200"
                            >
                                <td
                                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                                >
                                    TAD's Evidence Supports This Value
                                </td>
                                <td
                                    v-if="userProperty.show_2022_field"
                                    class="whitespace-nowrap px-3 py-4 w-28 text-right text-sm text-gray-500"
                                >
                                    <p></p>
                                </td>
                                <td
                                    class="whitespace-nowrap px-3 py-4 w-28 text-right text-sm text-gray-500"
                                >
                                    <p>
                                        ${{
                                            userProperty.tad_evidence_support_this_value
                                        }}
                                    </p>
                                </td>
                            </tr>
                            <tr class="divide-x divide-gray-200">
                                <td
                                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                                >
                                    Proposed Value
                                </td>
                                <td
                                    v-if="userProperty.show_2022_field"
                                    class="whitespace-nowrap px-3 py-4 w-28 text-right text-sm text-gray-500"
                                >
                                    <p>
                                        ${{
                                            userProperty.last_year_property
                                                .tad_proposed_market_value
                                        }}
                                    </p>
                                </td>
                                <td
                                    class="whitespace-nowrap px-3 py-4 w-28 text-sm text-right text-gray-500"
                                >
                                    <p>
                                        ${{
                                            userProperty.tad_proposed_market_value
                                        }}
                                    </p>
                                </td>
                            </tr>
                            <tr class="divide-x divide-gray-200">
                                <td
                                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                                >
                                    Amount of Reduction
                                </td>
                                <td
                                    v-if="userProperty.show_2022_field"
                                    class="whitespace-nowrap px-3 py-4 w-28 text-sm text-right text-gray-500"
                                >
                                    <p>
                                        ${{
                                            userProperty.last_year_property
                                                .amount_of_reduction
                                        }}
                                    </p>
                                </td>
                                <td
                                    class="whitespace-nowrap px-3 py-4 text-sm w-28 text-right text-gray-500"
                                >
                                    <p>
                                        ${{ userProperty.amount_of_reduction }}
                                    </p>
                                </td>
                            </tr>
                            <tr class="divide-x divide-gray-200">
                                <td
                                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6"
                                >
                                    Final Market Value After Protest
                                </td>
                                <td
                                    v-if="userProperty.show_2022_field"
                                    class="whitespace-nowrap px-3 py-4 text-right w-28 text-sm text-gray-500"
                                >
                                    <p>
                                        ${{
                                            userProperty.last_year_property
                                                .final_market_value
                                        }}
                                    </p>
                                </td>
                                <td
                                    class="whitespace-nowrap px-3 py-4 text-sm w-28 text-right text-gray-500"
                                >
                                    <p>
                                        ${{ userProperty.final_market_value }}
                                    </p>
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    userProperty.is_data_exemption_relation_present
                                "
                                class="divide-x divide-gray-200"
                            >
                                <td
                                    class="py-4 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6"
                                >
                                    The largest portion of your tax bill will be
                                    calculated based on this number after the
                                    new tax reform laws go into effect later
                                    this year:
                                </td>
                                <td
                                    v-if="userProperty.show_2022_field"
                                    class="whitespace-nowrap px-3 py-4 text-right w-28 text-sm font-semibold text-gray-700"
                                >
                                    <p></p>
                                </td>
                                <td
                                    class="whitespace-nowrap px-3 py-4 text-right w-28 text-sm font-semibold text-gray-700"
                                >
                                    <p>
                                        ${{ userProperty.data_exemption_value }}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="flex justify-start">
                    <a
                        v-if="
                            userProperty.protest_request &&
                            userProperty.final_order_pdf &&
                            userProperty.final_order_pdf.filepath
                        "
                        :href="
                            '/protest-requests/' +
                            userProperty.protest_request.uid +
                            '/download-final-order-pdf'
                        "
                        class="cursor-pointer w- inline-flex items-center justify-center px-3 py-1.5 rounded-md text-xs font-medium bg-green-600 text-white leading-6 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    >
                        <i class="fa fa-download mr-1.5 text-sm leading-6"></i>
                        Download Final Order
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
import Message from "../FinalOutcome/Message.vue";

export default {
    props: [
        "user",
        "user-properties",
        "donation-success",
        "reduction-statement",
        "signature",
    ],
    data() {
        return {};
    },
    components: {
        Message,
    },
    created() {},
    methods: {},
};
</script>
